import { AddAlert } from '../../../../component';
import { buildCoordinates } from '../../../../shared/utils/map';
import { loading, loaded } from '../../../../layout/redux/layoutActions';
import {
  getSalesCharts,
  getHarvestCharts,
  getReleasesSalesStockCharts,
  getEcoAndMapCharts,
  getWeightedAverageChart,
  getWeightedAverageChartEcoMap,
  getReleasesSalesStockChartsEcoMap,
  getSalesChartsEcoMap,
  getInfoWindow,
  getBuildingDetails,
  getBigNumbersPrimary,
  getBuildingsCompaniesLists,
  filterByCompanies,
} from './offersPrimary.infra';
import {
  updateRequestStatus,
  updateInputIntervalsPrimary,
  closeInfowindowsPrimary,
  updateBuildingData,
  setLaunchingYears,
  setConstructionPattern,
  setStatus,
  setBuildings,
  setCompanies,
  updateDisplayPrimaryCharts,
  updateDisplayBigNumbersOffersPrimary,
  setInfowindowsPrimary,
  updateChartsDataPrimary,
} from './offersPrimary.actions';
import {
  modalOpen,
  setDisplayCharts,
  setIsLoadingMap,
} from '../../redux/dashboardActions';
import {
  addIWListener,
  createOpenInfoWindow,
  generateMarkersOnMap,
} from './offersPrimary.map';
import { setBigNumbers } from '../../bigNumbers/redux/bigNumbersActions';
import {
  setMaxDate,
  setMaxUsefulArea,
  setMinDate,
  setMinUsefulArea,
  setRealtyType,
} from '../../charts/redux/charts.actions';
import api from '../../../../helpers/api';
import { getLocalStorageItem } from '../../../../helpers/localStorateHelper';
import { LocalStorageMapper } from '../../../../shared/constants';
import { getHeatmapDataFromBigNumber } from '../../heatmap/controllers/heatmap.controller';

let loadingStateController = {
  bigNumbers: false,
  companies: false,
};

export const searchRealtyOffersPrimary = (payload) => {
  return (dispatch) => {
    dispatch(loading());

    const realtyType = payload.realtyType.id;

    if (realtyType === 'cs' || realtyType === 'comm') {
      payload.selectedConstructionPattern = [];

      dispatch([
        generateBigNumbersPrimary(payload, 'primaryMarket'),
        getSalesCharts(payload),
        getHarvestCharts(payload),
        getReleasesSalesStockCharts(payload),
        getWeightedAverageChart(payload),
        generateLaunchedUnitsChart(payload),
      ]);
    } else {
      const isEco =
        payload.selectedConstructionPattern.filter((el) => el.name === 'ECO')
          .length === 1;
      const isMap =
        payload.selectedConstructionPattern.filter((el) => el.name === 'MAP')
          .length === 1;
      const isEcoAndMap =
        (isEco && isMap) || payload.selectedConstructionPattern.length === 0;
      const displayChartsValue = isEcoAndMap
        ? 'primaryMarketEcoMap'
        : 'primaryMarket';
      dispatch([
        generateBigNumbersPrimary(payload, displayChartsValue),
        // setDisplayCharts(displayChartsValue),
        getSalesCharts(payload),
        getHarvestCharts(payload),
        getReleasesSalesStockCharts(payload),
        getEcoAndMapCharts(payload),
        getWeightedAverageChart(payload),
        getWeightedAverageChartEcoMap(payload),
        getReleasesSalesStockChartsEcoMap(payload),
        getSalesChartsEcoMap(payload),
      ]);
    }

    dispatch(updateCompaniesFilter(payload, false, true));
  };
};

export const handlePriceInputs = (e, v, tuple, type) => {
  let name;
  let maskedValue = '';
  const replaceDots = e.value.replaceAll('.', '').split('R$');
  const valueAsFloat =
    replaceDots.length === 2
      ? parseInt(replaceDots[1])
      : parseInt(replaceDots[0]);
  if (!Number.isNaN(valueAsFloat)) {
    maskedValue = valueAsFloat.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0,
    });
  }
  if (e.name.includes('min')) {
    tuple.min = maskedValue;
    name = e.name.split('min')[0];
  } else {
    tuple.max = maskedValue;
    name = e.name.split('max')[0];
  }
  const payload = {
    name,
    value: tuple,
  };
  return (dispatch) => {
    dispatch(updateInputIntervalsPrimary(payload));
  };
};

export const handleInputsIntervals = (e, v, tuple, type, typeNumber) => {
  return (dispatch) => {
    let name;
    if (!Number.isNaN(parseInt(e.value)) && parseInt(e.value) < 0) return;
    if (!e.value.match(/^(?:[1-9]\d*|0)?(?:\.\d+)?$/) && e.value.length > 0) {
      return;
    }

    if (e.name.includes('min')) {
      tuple.min =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
      name = e.name.split('min')[0];
    } else {
      name = e.name.split('max')[0];
      tuple.max =
        typeNumber === 'int'
          ? !Number.isNaN(parseInt(e.value))
            ? parseInt(e.value)
            : ''
          : !Number.isNaN(e.value)
          ? e.value
          : '';
    }
    const payload = {
      name,
      value: tuple,
    };

    dispatch(updateInputIntervalsPrimary(payload));
  };
};

const fieldsDictionary = {
  timeframemin: 'Período Inicial',
  timeframemax: 'Período Final',
  privateAreaIntervalmin: 'Área Privativa Inicial',
  privateAreaIntervalmax: 'Área Privativa Final',
  unitPricemin: 'Faixa de preço da Unidade Inicial',
  unitPricemax: 'Faixa de preço da Unidade Final',
  pricePerSquareMtmin: 'Faixa de preço/m² Inicial',
  pricePerSquareMtmax: 'Faixa de preço/m² Final',
  realtyAgemin: 'Idade do Imóvel Inicial',
  realtyAgemax: 'Idade do Imóvel Final',
};

export const validateForm = (
  formData,
  validation,
  type,
  moreFilters,
  isBuildingFilter = false
) => {
  let flag = false;
  return (dispatch) => {
    if (!formData.realtyType.id) {
      dispatch(AddAlert('warning', 'Tipo de imóvel é um campo obrigatório'));
      flag = true;
    }
    if (!Object.values(validation)?.every((el) => el === false)) {
      const removedFalses = Object.entries(validation).filter(
        (el) => el[1] !== false
      );
      const errors = removedFalses.map((el) => fieldsDictionary[el[0]]);
      const invalidFields = errors.join(', ');
      const isPlural = errors.length > 1;
      dispatch(
        AddAlert(
          'warning',
          `Campo${isPlural ? 's' : ''} inválido${
            isPlural ? 's' : ''
          }: ${invalidFields}`
        )
      );
      flag = true;
    }
    if (!flag) {
      dispatch([payloadBuilder(formData, null, type, !!isBuildingFilter)]);
    }
  };
};

export const generateInfoWindow = (rgi, marker) => {
  const timeframeData = localStorage.getItem('TimeFrame');
  const timeframe =
    timeframeData && timeframeData !== 'undefined'
      ? JSON.parse(timeframeData)
      : '';

  const payload = timeframe
    ? {
        rgi,
        timeframe,
      }
    : {
        rgi,
      };

  return (dispatch) => {
    dispatch(setIsLoadingMap(true));
    Promise.resolve(getInfoWindow(payload))
      .then((res) => {
        dispatch(closeInfowindowsPrimary());
        const iw = createOpenInfoWindow({ data: res?.data, marker, rgi });
        dispatch(setInfowindowsPrimary(iw));
        dispatch(addIWListener(payload));
      })
      .catch((err) => console.error(err))
      .finally((_) => dispatch(setIsLoadingMap(false)));
  };
};

export const generateBuildingDetailsModal = (payload) => {
  return (dispatch) => {
    dispatch(setIsLoadingMap(true));
    Promise.resolve(getBuildingDetails(payload))
      .then((res) => {
        dispatch(updateBuildingData(res.data));
        dispatch(modalOpen('open building'));
      })
      .finally((_) => dispatch(setIsLoadingMap(false)));
  };
};

const generateLaunchedUnitsChart = (payload) => (dispatch) => {
  dispatch(updateRequestStatus({ name: 'launchedUnits', value: 'LOADING' }));
  api
    .post(
      'developer/bloomberg/primary-market/launched-units-graph/eco-map',
      payload
    )
    .then((res) => {
      dispatch([
        updateRequestStatus({ name: 'launchedUnits', value: 'LOADED' }),
        updateChartsDataPrimary({
          name: 'eco_map',
          value: res.data.releases_sales_info,
        }),
      ]);
    })
    .catch((err) => {
      dispatch(updateRequestStatus({ name: 'launchedUnits', value: 'FAILED' }));
    });
};
export const generateEcoAndMapCharts = () => {};
export const generateHarvestCharts = () => {};
export const generateWeightedAverageChart = () => {};
export const generateWeightedAverageChartEcoMap = () => {};
export const generateSalesCharts = () => {};
export const generateReleasesSalesStockCharts = () => {};
export const generateSalesChartsEcoMap = () => {};
export const generateReleasesSalesStockChartsEcoMap = () => {};

export const generateBuildingsCompaniesLists = () => {
  const launchingYearsPrimary = getLocalStorageItem(
    LocalStorageMapper.LaunchingYearsPrimary
  );
  const constructionPatterns = getLocalStorageItem(
    LocalStorageMapper.ConstructionPatterns
  );
  const statuses = getLocalStorageItem(LocalStorageMapper.Statuses);
  const buildingsNames = getLocalStorageItem(LocalStorageMapper.BuildingsNames);
  const companies = getLocalStorageItem(LocalStorageMapper.Companies);

  return (dispatch) => {
    if (
      launchingYearsPrimary &&
      constructionPatterns &&
      statuses &&
      buildingsNames &&
      companies
    ) {
      dispatch([
        setLaunchingYears(launchingYearsPrimary),
        setConstructionPattern(constructionPatterns),
        setStatus(statuses),
        setBuildings(buildingsNames),
        setCompanies(companies),
      ]);
    } else {
      Promise.resolve(getBuildingsCompaniesLists())
        .then((response) => {
          const responsePath = response?.data;

          dispatch([
            setLaunchingYears(responsePath?.launching_years),
            setConstructionPattern(responsePath?.construction_patterns),
            setStatus(responsePath?.statuses),
            setBuildings(responsePath?.buildings_names),
            setCompanies(responsePath?.real_state_developers),
          ]);
          localStorage.setItem(
            LocalStorageMapper.LaunchingYearsPrimary,
            JSON.stringify(responsePath?.launching_years)
          );
          localStorage.setItem(
            LocalStorageMapper.ConstructionPatterns,
            JSON.stringify(responsePath?.construction_patterns)
          );
          localStorage.setItem(
            LocalStorageMapper.Statuses,
            JSON.stringify(responsePath?.statuses)
          );
          localStorage.setItem(
            LocalStorageMapper.BuildingsNames,
            JSON.stringify(responsePath?.buildings_names)
          );
          localStorage.setItem(
            LocalStorageMapper.Companies,
            JSON.stringify(responsePath?.real_state_developers)
          );
        })
        .catch((err) => console.error(err));
    }
  };
};

export const updateCompaniesFilter = (
  payload,
  isUpdate = false,
  filter = false,
  firstRun = false
) => {
  return (dispatch) => {
    dispatch(loading());

    Promise.resolve(filterByCompanies(payload))
      .then((response) => {
        const responsePath = response?.data?.data;

        if (filter) {
          dispatch([
            setCompanies(responsePath?.real_state_developers),
            setBuildings(responsePath?.buildings_names),
          ]);
        } else {
          dispatch(setBuildings(responsePath?.buildings_names));
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally((_) => {
        dispatch(setIsLoadingMap(false));
        loadingStateController.companies = true;
        if (firstRun) loadingStateController.bigNumbers = true;
        if (loadingStateController.bigNumbers) {
          dispatch(loaded());
          loadingStateController.bigNumbers = false;
          loadingStateController.companies = false;
        }
      });
  };
};

export const generateOffersPrimaryCharts = () => {
  return (dispatch) => {
    dispatch(updateDisplayPrimaryCharts(true));
  };
};

export const generateBigNumbersPrimary = (payload, displayChartsValue) => {
  return (dispatch) => {
    dispatch(loading());
    Promise.resolve(getBigNumbersPrimary(payload))
      .then((res) => {
        const { pins, ...bigNumbers } = res?.data;

        if (
          payload?.inputIntervals?.timeframe &&
          payload?.inputIntervals?.timeframe?.min !== '' &&
          payload?.inputIntervals?.timeframe?.max !== ''
        ) {
          localStorage.setItem(
            'TimeFrame',
            JSON.stringify(payload?.inputIntervals?.timeframe)
          );
        } else {
          localStorage.setItem('TimeFrame', '');
        }
        getHeatmapDataFromBigNumber(pins, bigNumbers, 'primaryMarket');
        dispatch([
          generateMarkersOnMap(pins, 'primary'),
          setBigNumbers(bigNumbers),
          setDisplayCharts(displayChartsValue),
          setRealtyType(payload?.realtyType?.name),
          // updateDisplayBigNumbersOffersPrimary(true),
          setIsLoadingMap(false),
        ]);
        if (payload?.inputIntervals?.timeframe) {
          dispatch([
            setMinDate(payload?.inputIntervals?.timeframe?.min),
            setMaxDate(payload?.inputIntervals?.timeframe?.max),
          ]);
        }
        if (payload?.inputIntervals?.privateAreaInterval) {
          dispatch([
            setMinUsefulArea(payload?.inputIntervals?.privateAreaInterval?.min),
            setMaxUsefulArea(payload?.inputIntervals?.privateAreaInterval?.max),
          ]);
        }
      })
      .catch((err) => {
        dispatch(setDisplayCharts(null));
        console.error(err);
      })
      .finally((_) => {
        dispatch(setIsLoadingMap(false));
        loadingStateController.bigNumbers = true;
        if (loadingStateController.companies) {
          dispatch(loaded());
          loadingStateController.bigNumbers = false;
          loadingStateController.companies = false;
        }
      });
  };
};

export const payloadBuilder = (
  data,
  moreFilters,
  type,
  isBuildingFilter = false,
  isUpdate = false,
  filterType = ''
) => {
  const location = buildCoordinates();
  const building = filterType === 'building';

  let inputIntervals = {};
  Object.keys(data.inputIntervals).map((el) => {
    const val = data.inputIntervals[el];
    if (val.min !== '' && val.max !== '') {
      let valor;
      const validateValue = {
        min: val.min,
        max: val.max,
      };
      if (val.min.includes('R$')) {
        validateValue.min = val.min.split('R$')[1].replaceAll('.', '');
      }
      if (val.max.includes('R$')) {
        validateValue.max = val.max.split('R$')[1].replaceAll('.', '');
      }
      valor =
        el === 'timeframe'
          ? { min: val.min, max: val.max }
          : { min: Number(validateValue.min), max: Number(validateValue.max) };
      inputIntervals = { ...inputIntervals, [el]: valor };
    }
  });
  const newData = {
    ...data,
    inputIntervals,
  };
  if (!location && !isBuildingFilter) {
    return (dispatch) => {
      dispatch(AddAlert('warning', 'Selecione uma área no mapa'));
    };
  } else {
    const bedrooms = newData.bedrooms
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const suites = newData.suites
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const garages = newData.garages
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const payload = moreFilters
      ? {
          location,
          ...newData,
          bedrooms,
          suites,
          garages,
          moreFilters,
        }
      : {
          location,
          ...newData,
          bedrooms,
          suites,
          garages,
        };
    return (dispatch) => {
      if (isBuildingFilter) {
        dispatch(updateCompaniesFilter(payload, !!isUpdate, building, true));
      } else {
        dispatch(searchRealtyOffersPrimary(payload));
      }
    };
  }
};
